export default __webpack_public_path__ + "static/scores@768_2x-cdf0a326d0dd727a1c197e808674c0eb.webp";